import { useNavigate } from "react-router-dom";
import { Pencil, Trash2, ExternalLink } from "lucide-react";
import moment from "moment";

function normalizeWhatsApp(value) {
  if (!value) return null;
  const digits = String(value).replace(/\D/g, "");
  return digits.length >= 9 ? digits : null;
}

function formatSchedule(date, timeStart, timeEnd) {
  if (!date) return "—";
  const d = moment(date);
  if (!d.isValid()) return "—";
  const dateStr = d.locale("id").format("D MMMM YYYY");
  const start = timeStart || "--.--";
  const end = timeEnd ? ` - ${timeEnd}` : "";
  return `${dateStr}, ${start}${end}`;
}

export default function EventTable({
  events = [],
  loading,
  error,
  onEdit,
  onDelete,
}) {
  const navigate = useNavigate();

  if (loading) return <div className="table-empty">Memuat event…</div>;
  if (error) return <div className="table-empty error">{error}</div>;

  return (
    <div className="event-table">
      <table>
        <thead>
          <tr>
            <th>Event</th>
            <th>Jadwal</th>
            <th>Tiket Terjual</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>

        <tbody>
          {events.map((e) => {
            const totalQuota = e.totalQuota ?? 0;
            const sold = e.sold ?? 0;
            const percent = e.percent ?? 0;
            const isSoldOut = totalQuota > 0 && sold >= totalQuota;
            const wa = normalizeWhatsApp(e.whatsappPic);

            return (
              <tr key={e._id} className="event-row">
                {/* EVENT */}
                <td className="event-cell">
                  <img
                    src={e.headerImage?.url || "/placeholder-event.jpg"}
                    alt={e.title}
                    className="event-thumb"
                  />
                  <div className="event-info">
                    <span className="event-title">{e.title}</span>
                    <span className="event-location">
                      {e.location?.name || "—"}
                    </span>
                    {wa && (
                      <span className="event-wa">WA: {wa}</span>
                    )}
                  </div>
                </td>

                {/* SCHEDULE */}
                <td className="schedule-cell">
                  <span className="schedule-text">
                    {formatSchedule(e.date, e.timeStart, e.timeEnd)}
                  </span>
                </td>

                {/* TICKETS */}
                <td className="tickets-cell">
                  <div className="tickets-info">
                    <span className="tickets-count">
                      <strong>{sold}</strong>
                      <span className="tickets-sep"> / </span>
                      <span className="tickets-quota">
                        {totalQuota > 0 ? totalQuota : "∞"}
                      </span>
                    </span>
                    {totalQuota > 0 && (
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: `${percent}%` }}
                        />
                      </div>
                    )}
                    <span className="tickets-percent">{percent}%</span>
                  </div>
                </td>

                {/* STATUS */}
                <td className="status-cell">
                  <span className={`status-badge status-${e.status}`}>
                    {e.status === "published"
                      ? "Published"
                      : e.status === "draft"
                      ? "Draft"
                      : e.status === "closed"
                      ? "Closed"
                      : e.status}
                  </span>
                </td>

                {/* ACTIONS */}
                <td className="actions-cell">
                  <div className="actions-row">
                    {e.status === "published" && e.slug && (
                      <button
                        className="action-btn action-btn--public"
                        title="Lihat event publik"
                        onClick={(ev) => {
                          ev.stopPropagation();
                          window.open(`/events/${e.slug}`, "_blank");
                        }}
                      >
                        <ExternalLink size={14} />
                      </button>
                    )}

                    <button
                      className="action-btn action-btn--edit"
                      title="Edit event"
                      onClick={(ev) => {
                        ev.stopPropagation();
                        onEdit?.(e);
                      }}
                    >
                      <Pencil size={14} />
                    </button>

                    <button
                      className="action-btn action-btn--delete"
                      title="Arsipkan event"
                      onClick={(ev) => {
                        ev.stopPropagation();
                        if (window.confirm(`Arsipkan event "${e.title}"?`)) {
                          onDelete?.(e);
                        }
                      }}
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}